const SectionBlock = ({ id, children, className = '' }) => (
  <div
    id={id}
    className={`scroll-mt-40 rounded-xl border border-light-border-primary bg-light-bg-primary p-4 dark:border-dark-border-primary dark:bg-dark-bg-secondary sm:p-5 min-[992px]:scroll-mt-20 ${className}`}
  >
    {children}
  </div>
)

export default SectionBlock
